import { IntlMessageFormat } from 'intl-messageformat';
import type { Options } from 'intl-messageformat/src/core';
import type { Formats, PrimitiveType } from 'intl-messageformat/src/formatters';

import type { MessageFormatElement } from '@formatjs/icu-messageformat-parser';
import { DefaultTranspiler, getValue, isObject, setValue, TranspileParams } from '@jsverse/transloco';

type MFLocale = ConstructorParameters<typeof IntlMessageFormat>[1];
type MFFactoryFn = (message: string | MessageFormatElement[], values?: Record<string, PrimitiveType>) => string | string[] | undefined;

/**
 *
 */
function defaultFactory(locales: MFLocale, formats?: Partial<Formats>, opts?: Options): MFFactoryFn {
  return (message: string | MessageFormatElement[], values?: Record<string, PrimitiveType>) => {
    return new IntlMessageFormat(message, locales, formats, opts).format<string>(values);
  };
}

export class IntlMessageFormatTranspiler extends DefaultTranspiler {
  private mfFactory: MFFactoryFn;

  constructor() {
    super();
    this.mfFactory = defaultFactory('fr');
  }

  transpile(params: TranspileParams): any {
    if (!params.value) {
      return params.value;
    }
    if (isObject(params.value) && params.params) {
      Object.keys(params.params).forEach((p) => {
        const getParams = getValue<any>(params.params, p);
        const transpiled = super.transpile({ ...params, params: getParams });
        const message = this.mfFactory(transpiled, getParams);
        params.value = setValue(params.value, p, message);
      });
    } else if (!Array.isArray(params.value)) {
      const transpiled = super.transpile(params);
      try {
        return this.mfFactory(transpiled, params.params);
      } catch (_e) {
        return String(transpiled);
      }
    }
    return params.value;
  }

  onLangChanged(lang: string) {
    this.mfFactory = defaultFactory(lang);
  }
}
